module.exports = __webpack_public_path__ + "img/preview3.3181711f.png";